"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.fill.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.object.to-string.js");
var _default = exports.default = {
  methods: {
    /**
     * @description: 设置行序号
     * @param { Object } scope 行数据对象
     * @return { void }
     */
    setTableRowIndex: function setTableRowIndex(scope) {
      var _ref;
      var a = this.table.index;
      if (a && typeof a === 'function') return a(scope.row, scope.$index);
      var _this$pagination = this.pagination,
        currentPage = _this$pagination.currentPage,
        pageSize = _this$pagination.pageSize;
      return scope.$index + 1 + ((_ref = (currentPage - 1) * pageSize) !== null && _ref !== void 0 ? _ref : 0);
    },
    /** 行按钮显示分割线
     * @description: 行操作按钮是否显示分割线
     * @param { Number } rowIndex 行下标
     * @param { Number } index 行按钮下标
     * @param { Object } btn 按钮
     * @return { void }
     */
    rowBtnsCrossLine: function rowBtnsCrossLine(rowIndex, index /* , btn */) {
      var _this = this;
      /* 如果第一个按钮就不显示左侧的分割线 */
      if (index === 0) return false;

      /* 判断按钮是否存在 */
      var a = function a(i) {
        var btns = _this.$refs["row-operation-".concat(rowIndex, "-").concat(i)];
        var b = btns === null || btns === void 0 ? void 0 : btns.some(function (ref) {
          return !!(ref !== null && ref !== void 0 && ref.$el) && _this.$$dataTypeOf(ref === null || ref === void 0 ? void 0 : ref.$el, 0) !== 'comment' && _this.$$getOriginalStyle(ref === null || ref === void 0 ? void 0 : ref.$el, 'display') !== 'none';
        });
        return !!btns && b;
      };
      return a(index) && typeof new Array(index).fill('').find(function (v, i) {
        return a(i);
      }) !== 'undefined';
    }
  }
};